<template>
  <div id="tab">
    <div class="left">
      <div class="tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="用户管理" name="first" disabled>
            <span slot="label">
              <i
                class="iconfont"
                :class="{
                  'icon-feiji': type === 1,
                  'icon-xueshimao': type === 2,
                  'icon-kecheng': type === 3
                }"
              ></i>
              {{ type === 1 ? "权威发布" : type === 2 ? "专家观点" : "精选课程"}}
              <i class="el-icon-arrow-right"></i>
            </span>
          </el-tab-pane>
          <el-tab-pane
            v-for="(category, index) in pageData[
              type === 1 ? 'authority_data' : 'experts_data'
            ]"
            :key="index"
            :label="category.category_name"
            :name="String(index)"
          >
            <div class="content-box">
              <el-row>
                <el-col
                  class="content-col"
                  :class="{ 'content-col_1': type === 2 }"
                  :span="8"
                  v-for="(item, index) in category.data"
                  :key="index"
                  
                >
                  <lemma :data="{ item }" :type="type" v-if="index < 3"></lemma>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>


      </div>
    </div>
    <div class="right">
      <ranking
        v-if="type === 1"
        :type="this.type"
        :id="'hot'"
        :icon="'icon-jiangbei'"
        :title="'综合排行榜'"
        :data="pageData.popularity_ranking_data"
      ></ranking>
      <ranking
        v-if="type === 2"
        :type="this.type"
        :id="'click'"
        :icon="'icon-liulan'"
        :title="'浏览排行榜'"
        :data="pageData.browse_ranking_data"
      ></ranking>
      <!-- <ranking
        v-if="type === 2"
        :type="this.type"
        :id="'download'"
        :icon="'icon-xiazai'"
        :title="'下载排行榜'"
        style="margin-top:70px;"
        :data="pageData.download_ranking_data"
      ></ranking> -->
      <ranking
        v-if="type === 3"
        :type="this.type"
        :id="'hot'"
        :icon="'icon-huaban'"
        :title="'学习排行榜'"
        :data="pageData.popularity_ranking_data"
      ></ranking>
    </div>
  </div>
</template>

<script>
import Lemma from "./Lemma.vue";
import Ranking from "./Ranking.vue";

export default {
  name: "Tab",
  components: {
    Lemma,
    Ranking
  },
  props: {
    type: Number,
    pageData: Object
  },
  data() {
    return {
      activeName: "first"
    };
  },
  created() {
    setTimeout(() => {
      this.activeName = "0";
    }, 200);
  },
  methods: {
    handleClick() {
      if (this.type === 1) {
        // 权威发布
        this.$api.home
          .authority(
            this.pageData["authority_data"][this.activeName].category_no
          )
          .then(res => {
            this.pageData["authority_data"][this.activeName].data =
              res.data.data;
          })
          .catch();
      }
      if (this.type === 2) {
        // 专家观点
        this.$api.home
          .experts(this.pageData["experts_data"][this.activeName].category_no)
          .then(res => {
            this.pageData["experts_data"][this.activeName].data = res.data.data;
          });
      }

      if (this.type === 3) {
        // 精选课程
        
        // this.$api.home
        //   .authority(
        //     this.pageData["class_data"][this.activeName].category_no
        //   )
        //   .then(res => {
        //     this.pageData["class_data"][this.activeName].data =
        //       res.data.data;
        //   })
        //   .catch();
      }
    }
  }
};
</script>
<style scope lang="scss">
#tab {
  width: 1200px;
  margin: 14px auto;
  border-radius: 2px;
  background-color: #ffffff;
  display: flex;
  box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.11);
  .left {
    width: 940px;
    .tabs {
      .el-tabs__header {
        .el-tabs__item.is-disabled {
          font-size: 20px;
          color: #000000;
          padding-left: 25px;
          span {
            font-weight: 500;
          }
          .iconfont {
            font-size: 20px;
            margin-right: 10px;
          }
          .icon-xueshimao {
            font-size: 16px;
          }
        }
        .el-tabs__item.is-disabled:hover {
          color: #000000;
        }
        .el-tabs__active-bar {
          background-color: #25a257;
        }
        .el-tabs__item {
          height: 46px;
          line-height: 46px;
          font-weight: bold;
        }
        .el-tabs__item:hover {
          color: #25a257;
        }
        .is-active {
          color: #25a257;
        }
      }
      .content-box {
        .content-col {
          box-sizing: border-box;
          position: relative;
        }
        .content-col:nth-child(4)::before {
          content: " ";
          width: 899px;
          height: 1px;
          background-color: #f5f5f5;
          position: absolute;
          left: 20px;
          top: 0;
        }
        .content-col:nth-child(3n-1)::before {
          content: " ";
          width: 1px;
          height: 280px;
          background-color: #f5f5f5;
          position: absolute;
          left: 0;
          top: 20px;
        }
        .content-col:nth-child(3n-1)::after {
          content: " ";
          width: 1px;
          height: 280px;
          background-color: #f5f5f5;
          position: absolute;
          right: 0;
          top: 20px;
        }
        .content-col_1:nth-child(3n-1)::before,
        .content-col_1:nth-child(3n-1)::after {
          height: 338px;
        }
      }
    }
  }
}
</style>
